import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import { styled } from "styled-components";

const LanguageSwitch = ({ className = "" }) => {
  const { i18n } = useTranslation();

  const current = useMemo(
    () => i18n.language?.slice(0, 2) || "fr",
    [i18n.language],
  );

  const changeLanguage = (lang) => () => {
    i18n.changeLanguage(lang);
  };

  return (
    <LanguageWrap className={className}>
      <LangBtn onClick={changeLanguage("fr")} aria-current={current === "fr"}>
        FR
      </LangBtn>

      <span>
        <FaArrowRightArrowLeft />
      </span>

      <LangBtn onClick={changeLanguage("en")} aria-current={current === "en"}>
        EN
      </LangBtn>
    </LanguageWrap>
  );
};

export default LanguageSwitch;

const LanguageWrap = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;

  span {
    color: #fafafa;
  }

  @media (min-width: 2400px) {
    button {
      font-size: 2rem !important;
    }
  }

  @media (min-width: 1440px) {
    button {
      font-size: 1.3rem;
    }
  }

  @media (min-width: 280px) and (max-width: 1023px) {
    button {
      font-size: 1.5rem;
    }
  }
`;

const LangBtn = styled.button`
  border: none;
  background: transparent;
  color: #fafafa;
  font-size: 0.9rem;
  font-family: "Protest Revolution", sans-serif;
  text-transform: uppercase;
  padding: 1rem;
  cursor: pointer;

  /* optionnel : feedback visuel */
  &[aria-current="true"] {
    text-decoration: line-through;
    text-decoration-color: rgba(180, 1, 18, 1);
  }
`;
